<template>
  <v-layout justify-end>
    <v-btn
      v-if="!menuRouteCard"
      small
      icon
      class="ma-0"
      @click="menuRouteCard = true"
    >
      <v-icon>more_vert</v-icon>
    </v-btn>
    <v-menu
      v-else
      v-model="menuRouteCard"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          small
          class="ma-0"
          icon
          v-on="on"
        >
          <v-icon>more_vert</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-tile
          v-if="!routeId"
          @click="createRoute"
        >
          <v-list-tile-content>
            <v-layout align-center>
              <v-icon
                small
                outline
                color="grey lighnen-1"
                class="mr-1"
              >
                save
              </v-icon>
              <span>Сформировать</span>
            </v-layout>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="inCar ? false : deleteRoute()">
          <v-list-tile-content>
            <v-layout align-center>
              <v-icon
                small
                outline
                color="grey lighnen-1"
                class="mr-1"
              >
                {{ inCar ? "info" : "delete" }}
              </v-icon>
              <span>{{ inCar ? "Поставка в машине" : "Удалить" }}</span>
            </v-layout>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-menu>
  </v-layout>
</template>
<script>
export default {
  props: ["routeId", "inCar"],
  data() {
    return {
      menuRouteCard: false,
    };
  },
  methods: {
    createRoute() {
      this.$emit("create");
    },
    deleteRoute() {
      this.$emit("delete");
    },
  },
};
</script>
